import Vue from 'vue'
import axios from 'axios'
export default {
    state: {
        getUrl() {
            const instance = axios.create({
                // baseURL: 'http://localhost:3000'
                // baseURL: 'http://10.2.210.211:30308'
                baseURL: Vue.config['url']
            });
            instance.defaults.headers.common['x-auth-token'] = localStorage.getItem('token');
            instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
            return instance
        },
        // getUrl2(){
        //     const instance = axios.create({
        //         baseURL: 'http://localhost:3000'
        //         // baseURL: 'http://10.2.210.211:30308'
        //         // baseURL : process.env.VUE_APP_ROOT_API
        //     });
        //     //instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;
        //     instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
        //     return instance
        // }
    },
    saveGroup(data) {
        return axios.post('/custgroup/create', data)
            .then(function(response) {
                // console.log("createCampaign then")
                return Promise.resolve(response)
            })
            .catch(function(error) {
                // console.log("createCampaign catch")
                return Promise.reject(error)
            });
    },
    updateGroup(data) {
        return axios.put('/custgroup/' + data._id, data)
            .then(function(response) {
                // console.log("createCampaign then")
                return Promise.resolve(response)
            })
            .catch(function(error) {
                // console.log("createCampaign catch")
                return Promise.reject(error)
            });
    },
    listAll() {
        return axios.get('/custgroup/list')
            .then(function(response) {
                return Promise.resolve(response)
            })
            .catch(function(error) {
                // console.log("createCampaign catch")
                return Promise.reject(error)
            });
    },
    getAll(pagination) {
        return axios.get('/custgroup', {
                params: {
                    page: pagination.page,
                    perPage: pagination.perPage,
                    keyword: pagination.keyword
                }
            })
            .then(function(response) {
                // console.log("createCampaign then")
                return Promise.resolve(response)
            })
            .catch(function(error) {
                // console.log("createCampaign catch")
                return Promise.reject(error)
            });

    },
    getInfo(id) {
        return axios.get('/custgroup/' + id)
            .then(function(response) {
                // console.log("createCampaign then")
                return Promise.resolve(response)
            })
            .catch(function(error) {
                // console.log("createCampaign catch")
                return Promise.reject(error)
            });
    },
    getDetail(id) {
        return axios.get('/custgroup/details/' + id)
            .then(function(response) {
                // console.log("createCampaign then")
                return Promise.resolve(response)
            })
            .catch(function(error) {
                // console.log("createCampaign catch")
                return Promise.reject(error)
            });
    },
    deleteGroup(datas) {
        var id = (datas && datas.id) ? datas.id : '';
        var user = (datas && datas.code) ? datas.code : '';
        // return this.state.getUrl().delete('/custgroup/' + id)
        return this.state.getUrl().delete('/custgroup/', {
                data: {
                    "id": id,
                    "user": user
                }
            })
            .then(function(response) {
                // console.log("createCampaign then")
                return Promise.resolve(response.data)
            })
            .catch(function(error) {
                // console.log("createCampaign catch")
                return Promise.reject(error.response.data.error)
            });
    },
    searchGroup(keyword) {

        return axios.get('/custgroup/search', {
                params: {
                    "keyword": keyword
                }
            })
            .then(function(response) {
                // console.log("createCampaign then")
                return Promise.resolve(response)
            })
            .catch(function(error) {
                // console.log("createCampaign catch")
                return Promise.reject(error)
            });

    },
    // },
    checkIsActiveInCampaign(id) {
        return axios.get('/custgroup/isactive_incampaign/' + id)
            .then(function(response) {
                // console.log("createCampaign then")
                return Promise.resolve(response)
            })
            .catch(function(error) {
                // console.log("createCampaign catch")
                return Promise.reject(error)
            });
    },
    checkGroupName(data) {
        return axios.post('/custgroup/name-duplicate', data)
            .then(function(response) {
                // console.log("createCampaign then")
                return Promise.resolve(response)
            })
            .catch(function(error) {
                // console.log("createCampaign catch")
                return Promise.reject(error)
            });
    },
    checkGroupDelete(data) {
        return axios.post('/custgroup/delete-check', data)
            .then(function(response) {
                // console.log("createCampaign then")
                return Promise.resolve(response)
            })
            .catch(function(error) {
                // console.log("createCampaign catch")
                return Promise.reject(error)
            });
    },
    saveRemoveCustomer(custgroup_id, customers) {
        return axios.post('/custgroup/save-remove-customer', {
                custgroup_id: custgroup_id,
                customers: customers
            })
            .then(function(response) {
                // console.log("createCampaign then")
                return Promise.resolve(response)
            })
            .catch(function(error) {
                // console.log("createCampaign catch")
                return Promise.reject(error)
            });
    }
}